import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './authUi.module.css';

const LOGO_SRC = 'https://velox-network-media.s3.eu-west-2.amazonaws.com/Picture+2.png';

/**
 * Frame shared by login, register, forgot-password and reset-password: the dark
 * canvas, the compact wordmark, and a single card holding whatever the page asks
 * of the reader.
 *
 * `footer` is the cross-link to the other side of the flow (sign in ↔ register)
 * and sits inside the card; `note` sits under it and is for legal links.
 */
export default function AuthShell({ title, subtitle, children, footer, note, aside }) {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <div className={styles.page}>
      <div className={styles.backdrop} aria-hidden="true">
        <div className={styles.lattice} />
      </div>

      <main className={styles.shell}>
        <section className={styles.card}>
          {/* Inside the card rather than floating above it: at this size a
              wordmark on the bare canvas reads as a stray label. */}
          <Link to="/" className={styles.brand} aria-label="Velox Network — home">
            {logoFailed ? (
              <span className={styles.brandWordmark}>Velox</span>
            ) : (
              <img
                src={LOGO_SRC}
                alt="Velox Network"
                className={styles.brandLogo}
                width="109"
                height="22"
                onError={() => setLogoFailed(true)}
              />
            )}
          </Link>

          <header className={styles.header}>
            <h1 className={styles.title}>{title}</h1>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </header>

          {children}

          {footer && <div className={styles.footer}>{footer}</div>}
        </section>

        {note && <p className={styles.pageNote}>{note}</p>}
      </main>

      {aside}
    </div>
  );
}
